// Display helpers for user roles + account statuses. The API returns these
// lower-cased (e.g. "entrant", "pending"); the UI shows them title-cased and,
// for roles, as distinctly-coloured chips.

export function titleCase(s: string | null | undefined): string {
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

// Product-facing role names. Zitadel keeps the raw keys (Admin/User/Entrant);
// the UI shows these. NOTE: this is display-only — see NOC-374 for rolling the
// terminology through the backend + Zitadel.
export function roleDisplayName(role: string | null | undefined): string {
  switch ((role || '').toLowerCase()) {
    case 'admin':
      return 'Super admin';
    case 'user':
      return 'emap';
    case 'entrant':
      return 'Entrant';
    case 'pr':
      return 'PR';
    default:
      return titleCase(role);
  }
}

// Product-facing account-status names.
export function statusDisplayName(status: string | null | undefined): string {
  switch ((status || '').toLowerCase()) {
    case 'pending':
      return 'Pending first login';
    case 'active':
      return 'Active';
    case 'suspended':
      return 'Suspended';
    default:
      return titleCase(status);
  }
}

type ChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

/** Distinct MUI Chip colour per role. */
export function roleChipColor(role: string | null | undefined): ChipColor {
  switch ((role || '').toLowerCase()) {
    case 'admin':
      return 'error';
    case 'user':
      return 'info';
    case 'entrant':
      return 'success';
    case 'pr':
      // Distinct from admin(error)/user(info)/entrant(success).
      return 'secondary';
    default:
      return 'default';
  }
}

/** MUI Chip colour per account status. */
export function statusChipColor(status: string | null | undefined): ChipColor {
  switch ((status || '').toLowerCase()) {
    case 'active':
      return 'success';
    case 'pending':
      return 'warning';
    case 'disabled':
    case 'inactive':
    case 'suspended':
      return 'default';
    default:
      return 'default';
  }
}
